// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Inter", sans-serif;
}
.cookiePopup_UJaD_ {
  position: fixed;
  bottom: 0px;
  right: 0;
  background-color: #f7f7f8;
  border-radius: 8px;
  z-index: 999;
  display: flex;
  /* flex-direction: column; */
  gap: 15px;
  width: 100vw;
  padding: 16px 30px;
  box-sizing: border-box;
  /* border: 1px solid var(--ececf1-border); */
}
.textCookies_gXOIR{
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
  span{

    color: #808080;
  }
  a {
    color: #808080;
  }
  p {
    font-size: 15px;
    color: #000000;
    margin: 0;
  }

}
.HelpComponent_zXER7 {
  position: fixed;
  bottom: 40px;
  right: 40px;
  display: flex;
  align-items: end;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  gap: 20px;
  z-index: 999;
}

.helpText_iFAUH {
  display: flex;
  align-items: center;
  box-shadow: 4px 4px 10px rgba(150, 150, 150, 0.3);
  padding: 6px 20px;
  box-sizing: border-box;
  border-radius: 20px;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  -ms-border-radius: 20px;
  -o-border-radius: 20px;
  justify-content: space-between;
  gap: 10px;
  background-color: var(--white-color);
  p {
    color: #6e7a89;
  }
  .icon_hzYnZ {
    height: 40px;
    width: 40px;
    cursor: pointer;
  }
}
@media (width <= 485px) {
  .HelpComponent_zXER7 {
    right: 0;
    width: 100vw;
    max-width: fit-content;
  }
  .helpText_iFAUH {
    width: 100%;
  }
}
.helpContentArrow_akF6P {
  background-color: #2c2c2c;
  height: 80px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  -webkit-border-radius: 999px;
  -moz-border-radius: 999px;
  -ms-border-radius: 999px;
  -o-border-radius: 999px;
  cursor: pointer;
  box-shadow: 0px 0px 10px rgba(243, 239, 239, 0.122);
}



.cookiePopup_UJaD_ .buttons_USUME {
  display: flex;
  gap: 8px;
  align-items: center;
}

.cookiePopup_UJaD_ button {
  padding: 10px 12px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  background-color: var(--_10a37f-background);
  color: var(--white-color);
  flex: 1 1;
  border-radius: 7px;
  -webkit-border-radius: 7px;
  -moz-border-radius: 7px;
  -ms-border-radius: 7px;
  -o-border-radius: 7px;
}
.cookiePopup_UJaD_{
  .acceptButton_jExTx{
    background-color: #0000000f;
    border-radius: 999px;
    color: #000000;
    height: fit-content;
    text-wrap: nowrap;
  }
  .recjectButton_sJVGw{
    color: #000000;
    background-color: transparent;
    display: flex;
    align-items: center;
    gap: 5px;
    text-wrap: nowrap;
    svg{
      transform: rotate(90deg);
      fill: #000000;
    }
  }
}

@media (max-width: 500px) {
  .cookiePopup_UJaD_ {
    width: 80vw;
    bottom: 20px;
    right: 50%;
    transform: translateX(50%);
    border-radius: 20px;
    -webkit-transform: translateX(50%);
    -moz-transform: translateX(50%);
    -ms-transform: translateX(50%);
    -o-transform: translateX(50%);
    -webkit-border-radius: 20px;
    -moz-border-radius: 20px;
    -ms-border-radius: 20px;
    -o-border-radius: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/CookiePopup/CookiePopup.module.css"],"names":[],"mappings":"AAEA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,WAAW;EACX,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;;IAEE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;IACf,cAAc;IACd,SAAS;EACX;;AAEF;AACA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iDAAiD;EACjD,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,8BAA8B;EAC9B,SAAS;EACT,oCAAoC;EACpC;IACE,cAAc;EAChB;EACA;IACE,YAAY;IACZ,WAAW;IACX,eAAe;EACjB;AACF;AACA;EACE;IACE,QAAQ;IACR,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;AACF;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,mDAAmD;AACrD;;;;AAIA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,yBAAyB;EACzB,SAAO;EACP,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE;IACE,2BAA2B;IAC3B,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB;MACE,wBAAwB;MACxB,aAAa;IACf;EACF;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,UAAU;IACV,0BAA0B;IAC1B,mBAAmB;IACnB,kCAAkC;IAClC,+BAA+B;IAC/B,8BAA8B;IAC9B,6BAA6B;IAC7B,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;400;500;700&display=swap\");\n\nbody {\n  font-family: \"Inter\", sans-serif;\n}\n.cookiePopup {\n  position: fixed;\n  bottom: 0px;\n  right: 0;\n  background-color: #f7f7f8;\n  border-radius: 8px;\n  z-index: 999;\n  display: flex;\n  /* flex-direction: column; */\n  gap: 15px;\n  width: 100vw;\n  padding: 16px 30px;\n  box-sizing: border-box;\n  /* border: 1px solid var(--ececf1-border); */\n}\n.textCookies{\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  span{\n\n    color: #808080;\n  }\n  a {\n    color: #808080;\n  }\n  p {\n    font-size: 15px;\n    color: #000000;\n    margin: 0;\n  }\n\n}\n.HelpComponent {\n  position: fixed;\n  bottom: 40px;\n  right: 40px;\n  display: flex;\n  align-items: end;\n  flex-direction: column;\n  width: 100%;\n  max-width: 400px;\n  gap: 20px;\n  z-index: 999;\n}\n\n.helpText {\n  display: flex;\n  align-items: center;\n  box-shadow: 4px 4px 10px rgba(150, 150, 150, 0.3);\n  padding: 6px 20px;\n  box-sizing: border-box;\n  border-radius: 20px;\n  -webkit-border-radius: 20px;\n  -moz-border-radius: 20px;\n  -ms-border-radius: 20px;\n  -o-border-radius: 20px;\n  justify-content: space-between;\n  gap: 10px;\n  background-color: var(--white-color);\n  p {\n    color: #6e7a89;\n  }\n  .icon {\n    height: 40px;\n    width: 40px;\n    cursor: pointer;\n  }\n}\n@media (width <= 485px) {\n  .HelpComponent {\n    right: 0;\n    width: 100vw;\n    max-width: fit-content;\n  }\n  .helpText {\n    width: 100%;\n  }\n}\n.helpContentArrow {\n  background-color: #2c2c2c;\n  height: 80px;\n  width: 80px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 999px;\n  -webkit-border-radius: 999px;\n  -moz-border-radius: 999px;\n  -ms-border-radius: 999px;\n  -o-border-radius: 999px;\n  cursor: pointer;\n  box-shadow: 0px 0px 10px rgba(243, 239, 239, 0.122);\n}\n\n\n\n.cookiePopup .buttons {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.cookiePopup button {\n  padding: 10px 12px;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  background-color: var(--_10a37f-background);\n  color: var(--white-color);\n  flex: 1;\n  border-radius: 7px;\n  -webkit-border-radius: 7px;\n  -moz-border-radius: 7px;\n  -ms-border-radius: 7px;\n  -o-border-radius: 7px;\n}\n.cookiePopup{\n  .acceptButton{\n    background-color: #0000000f;\n    border-radius: 999px;\n    color: #000000;\n    height: fit-content;\n    text-wrap: nowrap;\n  }\n  .recjectButton{\n    color: #000000;\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    text-wrap: nowrap;\n    svg{\n      transform: rotate(90deg);\n      fill: #000000;\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .cookiePopup {\n    width: 80vw;\n    bottom: 20px;\n    right: 50%;\n    transform: translateX(50%);\n    border-radius: 20px;\n    -webkit-transform: translateX(50%);\n    -moz-transform: translateX(50%);\n    -ms-transform: translateX(50%);\n    -o-transform: translateX(50%);\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cookiePopup": `cookiePopup_UJaD_`,
	"textCookies": `textCookies_gXOIR`,
	"HelpComponent": `HelpComponent_zXER7`,
	"helpText": `helpText_iFAUH`,
	"icon": `icon_hzYnZ`,
	"helpContentArrow": `helpContentArrow_akF6P`,
	"buttons": `buttons_USUME`,
	"acceptButton": `acceptButton_jExTx`,
	"recjectButton": `recjectButton_sJVGw`
};
export default ___CSS_LOADER_EXPORT___;
